// Mobile compact swatch picker bridge.
// Forwards taps on .standard-color-quick-picker__swatch to the matching
// radio input in the canonical variant picker (rendered by product-blocks).
// The canonical picker's existing change/click handlers do all the heavy
// lifting (price, image, availability), so this is purely a UX shortcut.

(function() {
  function findCanonicalRadio(optionName, optionValue) {
    // The standard picker generates radios with id=ProductSelect-option-<name>-<value>
    // and name=<handleized option name>. Try id first (exact), fall back to name+value.
    var idCandidate = 'ProductSelect-option-' + optionName + '-' + optionValue;
    var byId = document.getElementById(idCandidate);
    if (byId) return byId;

    var radios = document.querySelectorAll('input[type=radio][name="' + cssEscape(optionName) + '"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === optionValue) return radios[i];
    }

    // Final fallback: any single-option-selector with matching data-index/name
    var generic = document.querySelectorAll('input[type=radio]');
    for (var j = 0; j < generic.length; j++) {
      if (generic[j].name === optionName && generic[j].value === optionValue) {
        return generic[j];
      }
    }
    return null;
  }

  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, function(c) { return '\\' + c; });
  }

  function syncSelectedStates(picker, optionName, optionValue) {
    picker.querySelectorAll('.standard-color-quick-picker__swatch[data-option-name="' + cssEscape(optionName) + '"]')
      .forEach(function(btn) {
        btn.classList.toggle('is-selected', btn.dataset.optionValue === optionValue);
      });
    var label = picker.querySelector('.standard-color-quick-picker__selected[data-option-name="' + cssEscape(optionName) + '"]');
    if (label) label.textContent = optionValue;
  }

  function onSwatchClick(e) {
    var btn = e.target.closest('.standard-color-quick-picker__swatch');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var picker = btn.closest('.standard-color-quick-picker');
    if (!picker) return;
    var optionName = btn.dataset.optionName;
    var optionValue = btn.dataset.optionValue;
    if (!optionName || !optionValue) return;

    var radio = findCanonicalRadio(optionName, optionValue);
    if (radio) {
      // Programmatic .click() fires the radio change which the standard
      // picker JS listens to (it updates the hidden id input + image).
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.click();
      }
    }

    syncSelectedStates(picker, optionName, optionValue);
  }

  function init() {
    var pickers = document.querySelectorAll('.standard-color-quick-picker');
    if (!pickers.length) return;
    pickers.forEach(function(picker) {
      if (picker.dataset.qpInit === '1') return;
      picker.dataset.qpInit = '1';
      picker.addEventListener('click', onSwatchClick);
    });

    // Mirror canonical picker → quick picker (when user changes variant
    // through the lower picker, our swatches above should reflect that).
    document.addEventListener('change', function(e) {
      var radio = e.target;
      if (!radio || radio.type !== 'radio') return;
      // Try to derive option name + value
      var name = radio.name;
      var value = radio.value;
      if (!name || !value) return;
      pickers.forEach(function(picker) {
        var sample = picker.querySelector('.standard-color-quick-picker__swatch[data-option-name="' + cssEscape(name) + '"]');
        if (!sample) return;
        syncSelectedStates(picker, name, value);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
